/* LIBRAIRIES */
import React, { useEffect, useState } from 'react';

/* FIREBASE */
import { getFirestore, collection, getDocs } from 'firebase/firestore';
import { auth } from '../../firebase';

/* CONTEXT */
import { useUserContext } from '../../useContext';

/* COMPONENT */
import DataGridUsers from '../DataGridUsers/DataGridUsers';
import DataGridMedias from '../DataGridMedias/DataGridMedias';
import ModalDeleteUser from '../ModalDeleteUser/ModalDeleteUser';
import ModalModifyUser from '../ModalModifyUser/ModalModifyUser';
import CustomAlert from '../CustomAlert/CustomAlert';

/* MUI */
import Button from '@mui/material/Button';

/* CSS */
import './UserList.css'; 

const UserList = () => {
    const [usersList, setUsersList] = useState([]);
    const { userId, setOpenModalUserDocs, userMediasList, openModalDeleteUser, openModalModifyUser, openModalUserDocs } = useUserContext();
    const [openAlert, setOpenAlert] = useState(false);
    const [alertSeverity, setAlertSeverity] = useState("success");
    const [alertMessage, setAlertMessage] = useState("");
    const [refreshUserList, setRefreshUserList] = useState(false);

    useEffect(() => {
        const db = getFirestore();
        const usersRef = collection(db, 'users');
        const getUsers = async () => {
            const data = await getDocs(usersRef);
            setUsersList(data.docs.map(doc => doc.data()));
        }
        getUsers();
    }, [refreshUserList]);

    const handleCloseAlert = () => {
        setOpenAlert(false);
    };

    console.log(usersList)
     
    return (
        <div className='container-userlist'>
            <DataGridUsers users={usersList}/>
            {
                openModalDeleteUser &&
                <ModalDeleteUser userId={userId} setOpenAlert={setOpenAlert} setAlertSeverity={setAlertSeverity} setAlertMessage={setAlertMessage} setRefreshUserList={setRefreshUserList} refreshUserList={refreshUserList} />
            }
            {
                openModalModifyUser &&
                <ModalModifyUser userId={userId} setOpenAlert={setOpenAlert} setAlertMessage={setAlertMessage} setAlertSeverity={setAlertSeverity} setRefreshUserList={setRefreshUserList} refreshUserList={refreshUserList}/>
            }
            {
                openModalUserDocs && 
                    <div className='container-modal-docs'>
                        <div className='content-modal-docs'>
                            <div className='body-modal-docs'>
                                { 
                                    userMediasList && <DataGridMedias userId={userId} userMedias={userMediasList} composant='modal'/>
                                }
                            </div>
                            <div className='footer-modal-docs'>
                                <Button variant="contained" onClick={() => setOpenModalUserDocs(false)}>Fermer</Button>
                            </div>
                        </div> 
                    </div>
            }
            <CustomAlert 
                open={openAlert}
                onClose={handleCloseAlert}
                message={alertMessage}
                severity={alertSeverity}
            />
        </div>  
    ) 
}

export default UserList;